<!--
  適用法令コンポーネント
-->
<template>
  <div class="app-low-right q-gutter-xs">
    <div
      v-if="props.classificationCode === '2' || props.classificationCode === '3'"
      class="app-lows"
    >
      <label :class="props.classificationCode === '2' ? 'low-poison' : 'low-deleterious'">{{
        props.regName
      }}</label>
    </div>
    <div
      v-if="
        props.classificationCode === '5' ||
        props.classificationCode === '6' ||
        (props.prtrName !== null && props.prtrName !== '')
      "
      class="app-lows"
    >
      <label class="low-prtr">{{ props.prtrName }}</label>
    </div>
    <div
      v-if="props.classificationCode === '7' || (props.ishlName !== null && props.ishlName !== '')"
      class="app-lows"
    >
      <label class="low-safety">{{ props.ishlName }}</label>
    </div>
    <div
      v-if="
        props.classificationCode === '1' ||
        props.classificationCode === '4' ||
        props.classificationCode === '8'
      "
      class="app-lows flex items-center justify-center"
      style="width: 60%; margin: 0px"
    >
      <label
        class="low-none flex items-center justify-center"
        style="
          background-color: rgba(210, 210, 210, 0.8);
          font-size: 14px;
          line-height: 1.5;
          border-radius: 0;
          font-weight: bold;
          letter-spacing: 1px;
          padding: 4px 0;
          width: 100%;
        "
        >取り扱いは中止になりました。</label
      >
    </div>
    <div v-if="props.classificationCode === null" class="app-lows">
      <label class="low-none">-</label>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  // 分類グループコード
  classificationCode: string;
  // 毒物/劇物名
  regName: string;
  // 化管法
  prtrName: string;
  // 安衛法
  ishlName: string;
}

const props = defineProps<Props>();
</script>
<style scoped>
p {
  margin: 0;
}
</style>
